import React from 'react';
import { TrendingUp, Users, Eye, MousePointer } from 'lucide-react';

const Analytics = () => {
    return (
        <div className="max-w-5xl mx-auto space-y-8">
            <div className="flex justify-between items-center">
                <h1 className="text-2xl font-bold text-slate-900">Analytics & Growth</h1>
                <select className="p-2 border border-slate-200 rounded-lg text-sm bg-white">
                    <option>Last 30 Days</option>
                    <option>Last Quarter</option>
                    <option>Year to Date</option>
                </select>
            </div>

            {/* KPI Cards */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                {[
                    { label: 'Total Revenue', val: '$12,450', icon: TrendingUp, color: 'text-green-600' },
                    { label: 'Active Users', val: '1,205', icon: Users, color: 'text-blue-600' },
                    { label: 'Page Views', val: '45.2k', icon: Eye, color: 'text-purple-600' },
                    { label: 'Conv. Rate', val: '2.4%', icon: MousePointer, color: 'text-orange-600' },
                ].map((stat, i) => (
                    <div key={i} className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
                        <div className="flex justify-between items-start mb-2">
                            <p className="text-sm text-slate-500">{stat.label}</p>
                            <stat.icon size={18} className={stat.color} />
                        </div>
                        <h3 className="text-2xl font-bold text-slate-900">{stat.val}</h3>
                    </div>
                ))}
            </div>

            {/* Charts Placeholder */}
            <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
                    <h3 className="font-bold text-slate-900 mb-6">Revenue Growth</h3>
                    {/* CSS-only bar chart visualization */}
                    <div className="h-64 flex items-end justify-between gap-2">
                        {[35, 45, 30, 60, 75, 50, 65, 80, 70, 90, 85, 100].map((h, i) => (
                            <div key={i} className="w-full bg-indigo-50 hover:bg-primary transition-colors rounded-t" style={{ height: `${h}%` }}></div>
                        ))}
                    </div>
                    <div className="flex justify-between mt-4 text-xs text-slate-400 uppercase">
                        <span>Jan</span><span>Dec</span>
                    </div>
                </div>

                <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
                    <h3 className="font-bold text-slate-900 mb-6">Traffic Sources</h3>
                    <div className="space-y-4">
                        {[
                            { name: 'Organic Search (SEO)', val: '45%', w: '45%' },
                            { name: 'Direct', val: '25%', w: '25%' },
                            { name: 'Social Media', val: '20%', w: '20%' },
                            { name: 'Referral', val: '10%', w: '10%' },
                        ].map((item, i) => (
                            <div key={i}>
                                <div className="flex justify-between text-sm mb-1">
                                    <span className="text-slate-700 font-medium">{item.name}</span>
                                    <span className="text-slate-500">{item.val}</span>
                                </div>
                                <div className="w-full bg-slate-100 rounded-full h-2">
                                    <div className="bg-primary h-2 rounded-full" style={{ width: item.w }}></div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Analytics;
